import { cn } from "@/lib/utils";

type Props = {
  value: number;
  label: string;
};

export function CountdownDigits({ value, label }: Props) {
  const [d1, d2] = getDigits(value);

  return (
    <div
      className={cn(
        "group/digits flex flex-col items-center gap-0.5 last:after:hidden",
      )}
    >
      <div className="flex gap-0.5 after:content-[':'] after:self-start group-last/digits:after:hidden">
        <Digit value={d1} />
        <Digit value={d2} />
      </div>

      <span className="text-[10px] leading-2 text-center font-normal">
        {label}
      </span>
    </div>
  );
}

function getDigits(value: number): [string, string] {
  const str = String(value).padStart(2, "0");
  return [str[0], str[1]];
}

function Digit({ value }: { value: string }) {
  return (
    <span
      className={cn(
        "bg-grayscale-white border-[#cce6ff] rounded border px-1 h-lh",
      )}
      suppressHydrationWarning
    >
      {value}
    </span>
  );
}
